import axios from 'axios';
import ENV_CONFIG from './config';

   // Create an axios instance with the base URL of your FastAPI backend
   const api = axios.create({
     baseURL: 'http://localhost:8000', // Ensure this matches your backend URL
   });

   // Function to handle login
   export const login = async (email, password) => {
     try {
       const response = await api.post('/login', { email, password });
       return response.data;
     } catch (error) {
       throw new Error(error.response?.data?.detail || 'Login failed');
     }
   };

   // Function to handle registration
   export const register = async (email, password, environment) => {
     try {
       const response = await api.post('/register', { email, password, environment });
       return response.data;
     } catch (error) {
       throw new Error(error.response?.data?.detail || 'Registration failed');
     }
   };

   // Function to update policy
   export const updatePolicy = async (key, value) => {
     try {
       const response = await api.put('/policy', { key, value });
       return response.data;
     } catch (error) {
       throw new Error(error.response?.data?.detail || 'Policy update failed');
     }
   };

export async function apiRequest(url, options = {}) {
  const storedUser = JSON.parse(localStorage.getItem('user'));
  if (!storedUser) {
    throw new Error('User not logged in');
  }

  // Get environment from localStorage, default to 'dev'
  const environment = localStorage.getItem('environment') || 'dev';
  const { baseUrl, token } = ENV_CONFIG[environment];

  const headers = {
    ...options.headers,
    'Authorization': `${storedUser.IdToken}`,
  };

  try {
    const response = await fetch(url, { ...options, headers });

    if (response.status === 401) {
      // Attempt to refresh the token using environment-specific URL and token
      const refreshResponse = await fetch(
        `${baseUrl}/user-management/users/refresh-token`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'X-Accept-Version': 'v2',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            refreshToken: storedUser.RefreshToken,
            idToken: storedUser.IdToken,
          }),
        }
      );

      if (!refreshResponse.ok) {
        throw new Error('Failed to refresh token');
      }

      const refreshData = await refreshResponse.json();
      const newIdToken = refreshData.IdToken;
      const newAccessToken = refreshData.AccessToken;

      // Update local storage with new IdToken and AccessToken
      localStorage.setItem('user', JSON.stringify({ ...storedUser, IdToken: newIdToken, AccessToken: newAccessToken }));

      // Retry the original request with the new token
      headers['Authorization'] = newIdToken;
      const retryResponse = await fetch(url, { ...options, headers });
      return retryResponse.json();
    }

    return response.json();
  } catch (error) {
    throw new Error(error.message);
  }
}